import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddTransportationEntryComponent } from 'src/app/core/dialogs/add-transportation-entry/add-transportation-entry.component';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { TEAssignInvoiceComponent } from 'src/app/core/dialogs/teassign-invoice/teassign-invoice.component';
import { BtnCellRendererAssignDetails } from 'src/app/core/grid/btn-cell-render-assign-details';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { TransportationEntryService } from 'src/app/service/document-control/transportation-entry.service';
import { ExcelService } from 'src/app/service/excel.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-transportation-entry',
    templateUrl: './transportation-entry.component.html',
    styleUrls: ['./transportation-entry.component.scss'],
    standalone: false
})
export class TransportationEntryComponent implements OnInit {

  gridApi: any;
  successMessage: string;
  errorMessage: string;
  columnDefs = [];
  displayRowData = [];
  currentPageNo: number;
  currentPageBoolean: boolean = false;
  totalPage: number;
  currentPageForTotalPage: number;
  isLastPageFound: boolean;
  rowCount: number;
  defaultColDef: {};
  gridOptions
  icons: {};
  userID: number;
  context: {};
  shipmentTypesDropdown = [];
  isAccessible = false;
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  constructor(private readonly dialog: MatDialog, private readonly constants: Constants, private readonly router: Router, private readonly exportStateService: ExportStateService,
    private readonly transportationEntryService: TransportationEntryService, private readonly excelService: ExcelService,
    private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.columnDefs = [
      {
        headerName: "T&E NUMBER", field: "te_id", width: 100, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true,
      },
      {
        headerName: "TYPE", field: "frieghtType_type", width: 100, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true,
      },
      {
        headerName: "MODE", field: "shipmentType_mode", width: 100, suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true,
      },
      {
        headerName: "SETS", field: "sets", width: 100,
      },
      {
        headerName: "10401 PALLETS", field: "gstInvoice_10401", width: 100,
      },
      {
        headerName: "68683 PALLETS", field: "eolInvoice_68683", width: 100,
      },
      {
        headerName: "Total PALLETS", field: "totalPallets_pallets", width: 100,
      },
      {
        headerName: "WEIGHT", field: "weight", width: 100,
      },
      {
        headerName: "VALUE", field: "value", width: 100,
      },
      {
        headerName: "ASSIGN / DETAILS", field: "transportationentry_assigndetails", cellRenderer: BtnCellRendererAssignDetails, width: 100,
      },
      {
        headerName: "ACTIONS", field: "transportationentry_editdelete", cellRenderer: BtnCellRendererEditDelete, width: 100,
      }];
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    // this.checkRoles();
    this.transportationEntryService.loadShipmentsTypeDropDown().subscribe(
      response => {
        if (response && response.length > 0) {
          this.shipmentTypesDropdown = response
        }
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.refreshData();
      }, error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

      }
    );

  }
  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
		event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  refreshData(): void {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.transportationEntryService.loadDataTransportationEntry().subscribe(
      response => {

        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const headers = ['T&E Number', 'Freight Type', 'Shipment Type', 'Sets', '10401 Pallets', '68683 Pallets', 'Total Pallets', 'Weight', 'Value'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
       { linkData = this.displayRowData }
      linkData.forEach(e => {
        const obj = {
          TENumber: e.te_id,
          FreightType: e.frieghtType_type,
          ShipmentType: e.shipmentType_mode,
          Sets: e.sets,
          gstInvoice_10401: e.gstInvoice_10401,
          eolInvoice_68683: e.eolInvoice_68683,
          TotalPallets: e.totalPallets_pallets,
          Weight: e.weight,
          Value: e.value
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'TRANSPORTATION-ENTRY', headers);
    }
  }
  addTransportationEntry() {
    const dialogRef = this.dialog.open(
      AddTransportationEntryComponent, {
      disableClose: true,
      width: '520px',
      data: {
        header: 'Add Transportation Entry',
        eventType: 'ADD',
        shipmentTypesDropdown: this.shipmentTypesDropdown
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();

      }
    });
  }
  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeletePalletDialogComponent, {
      disableClose: true,
      width: 'max-content',
      data: {
        header: 'Are you sure you want to delete this Transportation Entry?',
        description: "T&E Number : " + data.te_id,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'ConfirmEvent') { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.transportationEntryService.deleteTransportationEntry(data.te_id).subscribe(
          response => {

            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              const displayRowIndex = this.displayRowData.findIndex(x => x.te_id == data.te_id) // NOSONAR
              this.displayRowData.splice(displayRowIndex, 1);
              this.gridApi?.setGridOption('rowData', this.displayRowData);
              this.rowCount = this.displayRowData.length;
            }
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

          }, _error => {

            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTimeShort);
          }
        );
      }
    });
  }

  detailsTemplateRow(data, _pagename) {
    if (data.te_id) {
      localStorage.setItem('transportation-entry-details', JSON.stringify(data.te_id));
      this.openRouteLevel('transportation-entry/transportation-entry-details')

    } else {
      this.errorMessage = "Error with TE Number.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTimeShort);

    }
  }
  editTemplateRow(data, _pagename) {
    
    const dialogRef = this.dialog.open(
      AddTransportationEntryComponent, {
      disableClose: true,
      width: '520px',
      data: {
        header: 'Edit Transportation Entry',
        eventType: 'EDIT',
        shipmentTypesDropdown: this.shipmentTypesDropdown,
        transportationEntryId: data.te_id,
        shipmentTypeId: data.shipment_type_id,
        container: data.container,
        seal: data.seal,
        waybill: data.waybill,
        comments: data.comments,
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.refreshData();
      }
    });
  }
  addTemplateRow(data, _pagename) {
    
    const dialogRef = this.dialog.open(
      TEAssignInvoiceComponent, {
      disableClose: true,
      width: '700px',
      height: '560px',
      data: {
        tenumber: data.te_id,
        eventType: 'EDIT',
        transportationEntryId: data.transportationEntryId,
        shipmentTypeId: data.shipment_type_id,
        number: data.number,
        container: data.container,
        seal: data.seal,
        waybill: data.waybill,
        isComplete: data.isComplete,
        comments: data.comments,
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.eventResponse == "Success") { // NOSONAR
          this.successMessage = this.constants.APIDataSaved;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTimeShort);
          this.refreshData();
        }
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route): void {
    this.router.navigate([`${route}`]);
  }

}
